import CommentDetail from './CommentDetail';

export default CommentDetail;
